// extracted by mini-css-extract-plugin
module.exports = {"styledEntityDetails":"wmd3sGPo","content":"z1oQP5db","chartWrapper":"oyzSGtmA","horizonLabel":"_Td2Bo3l"};